import React from 'react';
import UnderConstruction from 'common/components/UnderConstruction';


// TODO change nav
const Credits = () => {
  return (
    <div>
      <h1 style={{ textAlign: 'center', marginTop: '20px' }}>Credits</h1>
      <UnderConstruction />
    </div>
  );
};

export default Credits;